module.exports = __webpack_public_path__ + "static/media/icn_expert_match.ad664710.svg";